import React, { Component, useState } from 'react'
import { withRouter } from '../../../utils/with-router'
import avatar from '../../Home/Speaker/speakers_avatars/avatar.svg'
import paul from '../../Home/Speaker/speakers_avatars/paul.svg'
import han from '../../Home/Speaker/speakers_avatars/han.svg'
import alan from '../../Home/Speaker/speakers_avatars/alan.svg'
import chair from '../../Home/Speaker/speakers_avatars/chair.png'
import cochair from '../../Home/Speaker/speakers_avatars/cochair.png'
import { Link } from 'react-router-dom';

import './BoardMembers.css'
import { getBoardMembers } from '../../../fetcher'
class BoardMembers extends Component{

    constructor(props) {
        super(props);
        this.state = {
        
          boardMembersLists:[]
        
        };
      }

      componentDidMount() {
        this.fetchBoardMemberData();
      }

      fetchBoardMemberData = async () => {
        try {
          const memberData = await getBoardMembers();
          let memberList=[]
          console.log(memberData)
          memberData.records.forEach((speakerContentElement, index) => {
            const speaker = memberData.records[index].fields;
            let id = index
            let name = speaker.Name;
            let company =  speaker.Company? speaker.Company.split(';'):[]
            let position=speaker.Position
            let photo = speaker.Photo ? speaker.Photo[0].url : paul;
            let order = speaker.Order
            let memberDetail = {id:id, name: name, company: company, position: position, photo: photo,order: order}
            memberList.push(memberDetail)
          });

          this.setState({boardMembersLists: memberList})

        } catch (error) {
          console.error(error);
        }
      };

  

      render(){
        let MemberList = this.state.boardMembersLists.map((item,index)=>{
            return (
                <Link to={`/profile/boardmember/${item.order}`} key={item.id} className='boardmembers_newList-one'>
                <div className='boardmembers_speaker_content'>
                        <div className='boardmembers_speaker_avatar_container'>
                            <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='boardmembers_speaker_pic' src={item.photo} alt="pic" />
                            {index ==0 && <img className='extra-div1' src={chair} alt="pic"/>}
                        {index ==1 && <img className='extra-div2' src={cochair} alt="pic"/>}
                        </div>
                       

                        <div className='boardmembers_speaker'>
                        <h1 className='boardmembers_speaker_name'>{item.name}</h1>
                        <h4 className='boardmembers_speaker_position'>{item.position}</h4>
                        {/* <h4 className='boardmembers_speaker_company'>{item.company}</h4> */}
                        {item.company.map((com, index) => (
                            <h4 key={index} className='boardmembers_speaker_company'>{com}</h4>
                            ))}
                        </div>     
                    </div>
            </Link>)
        })
        return(
            <div className = "BOARDMEMBERS">
            <h2 class='panel_title'>Board Members</h2>
                <div className='boardmembers_speaker_container'>
                    {MemberList}
                    {/* <div className='boardmembers_speaker_content'>
                        <div className='boardmembers_speaker_avatar_container'>
                            <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='boardmembers_speaker_pic' src={paul} alt="pic" />
                        </div>
                        <h1 className='boardmembers_speaker_name'>Paul Chapman</h1>
                        <h4 className='boardmembers_speaker_position'>VP & Global CIO</h4>
                        <h4 className='boardmembers_speaker_company'>@Box</h4>
                    </div>
                    <div className='boardmembers_speaker_content'>
                        <div className='boardmembers_speaker_avatar_container'>
                            <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='boardmembers_speaker_pic_1' src={han} alt="pic" />
                        </div>
                        <h1 className='boardmembers_speaker_name' left='-10px'>Han-Shen(Han) Yuan</h1>
                        <h4 className='boardmembers_speaker_position'>EX-Senior VP of</h4>
                        <h4 className='boardmembers_speaker_position'>Engineering</h4>
                        <h4 className='boardmembers_speaker_company'>@Upwork</h4>
                    </div>
                    <div className='boardmembers_speaker_content'>
                        <div className='boardmembers_speaker_avatar_container'>
                            <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='boardmembers_speaker_pic_1' src={alan} alt="pic" />
                        </div>
                        <h1 className='boardmembers_speaker_name'>Alan Wang</h1>
                        <h4 className='boardmembers_speaker_position'>Founder @Alan Wang</h4>
                        <h4 className='boardmembers_speaker_company'>Realty Group</h4>
                    </div>
                </div>
            <div className='boardmembers_speaker_container'>
                <div className='boardmembers_speaker_content'>
                    <div className='boardmembers_speaker_avatar_container'>
                        <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='boardmembers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='boardmembers_speaker_name'>Paul Chapman</h1>
                    <h4 className='boardmembers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='boardmembers_speaker_company'>@Box</h4>
                </div>
                <div className='boardmembers_speaker_content'>
                    <div className='boardmembers_speaker_avatar_container'>
                        <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='boardmembers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='boardmembers_speaker_name'>Paul Chapman</h1>
                    <h4 className='boardmembers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='boardmembers_speaker_company'>@Box</h4>
                </div>
                <div className='boardmembers_speaker_content'>
                    <div className='boardmembers_speaker_avatar_container'>
                        <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='boardmembers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='boardmembers_speaker_name'>Paul Chapman</h1>
                    <h4 className='boardmembers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='boardmembers_speaker_company'>@Box</h4>
                </div>
                
            </div>
            <div className='boardmembers_speaker_container'>
                <div className='boardmembers_speaker_content'>
                    <div className='boardmembers_speaker_avatar_container'>
                        <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='boardmembers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='boardmembers_speaker_name'>Paul Chapman</h1>
                    <h4 className='boardmembers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='boardmembers_speaker_company'>@Box</h4>
                </div>
                <div className='boardmembers_speaker_content'>
                    <div className='boardmembers_speaker_avatar_container'>
                        <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='boardmembers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='boardmembers_speaker_name'>Paul Chapman</h1>
                    <h4 className='boardmembers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='boardmembers_speaker_company'>@Box</h4>
                </div>
                <div className='boardmembers_speaker_content'>
                    <div className='boardmembers_speaker_avatar_container'>
                        <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                        <img className='boardmembers_speaker_pic' src={paul} alt="pic" />
                    </div>
                    <h1 className='boardmembers_speaker_name'>Paul Chapman</h1>
                    <h4 className='boardmembers_speaker_position'>VP & Global CIO</h4>
                    <h4 className='boardmembers_speaker_company'>@Box</h4>
                </div>
                 */}
            </div>
            </div>
        )
      }
    }

export default BoardMembers;